import Tooltip from "@/tooltip";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import styles from "./Selectors.module.css";

export default function TableViewList({ options, value, onChange, ...props }) {
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState(value);

	const handleSelect = (option) => {
		setSelected(option);
		if (onChange) onChange(option);
		setOpen(false);
	};

	const optionList = options?.map((option) => {
		return (
			<div
				aria-selected={selected?.value === option?.value}
				className={styles["table-view-list-option"]}
				tabIndex={0}
				onClick={() => handleSelect(option)}
			>
				{option.label}
			</div>
		);
	});

	return (
		<button
			className={styles["table-view-list"]}
			tabIndex={0}
			onClick={(e) => e.target.focus()}
			onFocus={() => setOpen(true)}
			onBlur={() => setOpen(false)}
		>
			<Tooltip
				isOpen={open}
				direction="down"
				arrow={false}
				tabIndex={0}
				distance={10}
				contentClassName={styles["table-view-list-options"]}
				content={<>{optionList ? optionList : <div>No Options</div>}</>}
			>
				<span tabIndex={0}>{selected?.label ? selected.label : ""} View</span>
				<ChevronDownIcon
					className={`h-5 w-5 text-dark-gray ${open ? "rotate-180" : ""}`}
					tabIndex={0}
					style={{
						marginLeft: 5,
						verticalAlign: "text-top",
						transform: open ? "rotate(180deg)" : "rotate(0deg)",
						transition: "transform 0.2s ease-in-out",
					}}
				/>
			</Tooltip>
		</button>
	);
}
